// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TerritoriesRouteImport } from './routes/territories'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArmiesIndexRouteImport } from './routes/armies/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ArmiesArmyIdRouteImport } from './routes/armies/$armyId'
import { Route as MatchMatchIdPostMatchRouteImport } from './routes/match/$matchId/post-match'

const TerritoriesRoute = TerritoriesRouteImport.update({
            id: '/territories',path: '/territories',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ArmiesIndexRoute = ArmiesIndexRouteImport.update({
            id: '/armies/',path: '/armies/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const InviteTokenRoute = InviteTokenRouteImport.update({
            id: '/invite/$token',path: '/invite/$token',getParentRoute: () => rootRouteImport
          })
const ArmiesArmyIdRoute = ArmiesArmyIdRouteImport.update({
            id: '/armies/$armyId',path: '/armies/$armyId',getParentRoute: () => rootRouteImport
          })
const MatchMatchIdPostMatchRoute = MatchMatchIdPostMatchRouteImport.update({
            id: '/match/$matchId/post-match',path: '/match/$matchId/post-match',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,LoginRoute: LoginRoute,SettingsRoute: SettingsRoute,TerritoriesRoute: TerritoriesRoute,ArmiesArmyIdRoute: ArmiesArmyIdRoute,InviteTokenRoute: InviteTokenRoute,AdminIndexRoute: AdminIndexRoute,ArmiesIndexRoute: ArmiesIndexRoute,MatchMatchIdPostMatchRoute: MatchMatchIdPostMatchRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)